module.exports = __webpack_public_path__ + "img/logo.974a53f8.svg";